import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@ui-nuvertos/shared';
import { buildQueryString } from '../../utils/http-utils';

@Injectable({
  providedIn: 'root'
})
export class ClientOrderService {
  private readonly accountingUrl = environment.accountingUrl;

  constructor(private http: HttpClient) {}

  getClientOrders(filters?: any | Record<string, unknown>): Observable<any> {
    const url = `${this.accountingUrl}/api/v1/client-orders/${buildQueryString(filters, { include: 'client' })}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  deleteClientOrder(orderId: string | number): Observable<any> {
    const url = `${this.accountingUrl}/api/v1/client-orders/${orderId}`;
    return this.http.delete<any>(url, { withCredentials: true });
  }

  getClientOrderById(orderId: string | number): Observable<any> {
    const url = `${this.accountingUrl}/api/v1/client-orders/${orderId}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  createClientOrder(payload: Record<string, unknown>): Observable<any> {
    const url = `${this.accountingUrl}/api/v1/client-orders/`;
    return this.http.post<any>(url, payload, { withCredentials: true });
  }

  updateClientOrder(orderId: string, payload: Record<string, unknown>): Observable<any> {
    const url = `${this.accountingUrl}/api/v1/client-orders/${orderId}`;
    return this.http.put<any>(url, payload, { withCredentials: true });
  }

  /**
   * Cancel a client order
   * Endpoint: PATCH /api/v1/client-orders/{id}/cancel
   */
  cancelClientOrder(orderId: string | number): Observable<any> {
    const url = `${this.accountingUrl}/api/v1/client-orders/${orderId}/cancel`;
    return this.http.patch<any>(url, {}, { withCredentials: true });
  }

  /**
   * Get audit logs for a client order
   * Backend endpoint (per curl): GET /api/v1/client-orders/{id}/audit-logs
   */
  getAuditLogs(orderId: string | number, filterParams?: any): Observable<any> {
    const params = new HttpParams({ fromObject: filterParams || {} });
    const url = `${this.accountingUrl}/api/v1/client-orders/${orderId}/audit-logs`;
    return this.http.get<any>(url, { params, withCredentials: true });
  }

  /**
   * Get print data for a client order (for PDF generation)
   * Endpoint: GET /api/v1/client-orders/:id/print-data
   */
  getPrintData(orderId: string | number): Observable<any> {
    const url = `${this.accountingUrl}/api/v1/client-orders/${orderId}/print-data`;
    return this.http.get<any>(url, { withCredentials: true });
  }
}

